import React, { useEffect, useState } from 'react'
import Left_menu from './Left_menu'
import Header from './Header'
import Create_order_nav from './Create_order_nav'
import axios from 'axios'
import queryString from 'query-string';
import { useNavigate,useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';


import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"
import { useNetworkState } from 'react-use';
import { CornerUpLeft } from 'lucide-react'
import Footer from '../Footer'

const Channel_list = () => {
    let navigate = useNavigate();
    const[state,setState] = React.useState([])
    const [ statusState,setStatus] = React.useState(null)
    const isOnline = useNetworkState();
    const { pathname,search } = useLocation();
    const query = new URLSearchParams(search);
    const status = query.get("status");
    const oauth = query.get("oauth");
    const reason = query.get("reason");
    // console.log("isONline  === " ,isOnline )
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    React.useEffect(() => {
        if (!status) return;
    
        const showAlert = async () => {
          if (status === "success") {
            await Swal.fire("✅ Store Integrated", "Your Shopify store was added successfully!", "success");
          } else if (status === "failed") {
            await Swal.fire("❌ Integration Failed", "Something went wrong during installation.", "error");
          }
          else if (status === "already_connected") {
            await Swal.fire("❌ Store already connected", "This Shopify store is already linked to any other account.", "error");
          }
    
          // Clean up the URL after alert
          navigate(pathname, { replace: true });
        };
    
        showAlert();
      }, [status, pathname, navigate]);

      React.useEffect(() => {
        if (!oauth) return;
    
        const showAlert = async () => {
          if (oauth === "success") {
            await Swal.fire("✅ Credentials Updated", "success");
          } else if (oauth === "failed") {
            await Swal.fire(`❌ ${reason}`, "Something went wrong during.", "error");
          }
          
         
          // Clean up the URL after alert
          navigate(pathname, { replace: true });
        };
    
        showAlert();
      }, [oauth, pathname, navigate]);

    React.useEffect(()=>{
        getChannelList()
    },[])
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
    const getChannelList = () => {


        let url = config.apiUrl + '/user/channel_list';
        let sendData = {};
        // // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // // console.log("res ", res);  
            if(res.data.status==true){         
            setState(res.data.output)
            }
            else{
                Toast.fire({
                    background:"#c2200a",
                    type: 'unsuccess',
                    title: "Something Went Wrong",
                    color:"white"
                  });
            }
    
        }).catch((e) => {
            Toast.fire({
                background:"#c2200a",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color:"white"
              });
    
        });
    }
    const updateStatus = (status  , store_id) => {


        let url = config.apiUrl + '/user/update_store_status';
        let sendData = {status:status  , store_id:store_id};
        // // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            if(res.data.status==true){
            Toast.fire({
                background:"#001b72",
                type: 'unsuccess',
                title: "Updated Successfully",
                color:"white"
              });
            }
    
        }).catch((e) => {
    
            Toast.fire({
                background:"#c2200a",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color:"white"
              });
        });
    }

    const handleChange = (e,  store_id) => {
        // // console.log("e ", e.target.name);
        // // console.log("e checked", e.target.checked);
        if (e.target.checked == true) {
          setStatus({ ...statusState, status: 1 })
          updateStatus(1  , store_id)
        }
        else {
            setStatus({ ...statusState, status: 0 })
            updateStatus(0  , store_id)
        
        }
      }

      const updateStoreField = (store_id, key, value) => {
        setState((prev) =>
          prev.map((s) =>
            s.store_id === store_id ? { ...s, [key]: value } : s
          )
        );
      };
      const startShopifyOAuth = (store_id, shop, client_id , client_secret) => {
        if (!shop || !client_id || !client_secret) {
          return Swal.fire("Error", "Shop , Client ID & Client Secret required", "error");
        }

        
        let full_api = config.apiUrl + '/user/save_shopify_oauth_creds';
        let sendData = {  store_id: store_id , client_id:client_id , client_secret:client_secret , shop: shop };
        // console.log("bb", sendData);
        axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
            if (res.data.status == true) {
                const redirectUri = encodeURIComponent(
                    "https://backend.mojoship.in/auth/shopify/callback"
                  );
                
                  const scopes = encodeURIComponent(
                    "write_assigned_fulfillment_orders, read_assigned_fulfillment_orders, write_draft_orders, read_draft_orders, write_fulfillments, read_fulfillments, write_merchant_managed_fulfillment_orders, read_merchant_managed_fulfillment_orders, write_inventory, read_inventory, write_orders, read_orders, write_products, read_products, write_product_listings, read_product_listings, write_product_feeds, read_product_feeds"
                  );
                
                  const state = store_id;
                
                  const url = `https://${shop}/admin/oauth/authorize?client_id=${client_id}&scope=${scopes}&redirect_uri=${redirectUri}&state=${state}`;
                
                  window.location.href = url;
            }

        }).catch((e) => {

            Toast.fire({
                background: "#a61c09",
                type: 'unsuccess',
                title: "Something Went Wrong",
                color: "white"
            });
        });
      
       
      };
  return (
//     <div>
     
// <Left_menu value={11}/>
//     <section class="home ">
       
// <Header/>
        

//         <section class="mb-3 mt-3 tools">
//         <div class="container">
//             <div class="row py-3">
//                 <div class="col-12 col-md">
//                     <h3>Channel List</h3>
//                 </div>
//                 <div class="col-12 col-md-4 text-end">
//                     <a href="/customer/add_channel" class="btn btn-primary">Add Chanel</a>
//                 </div>
//             </div>
//             <div class="row chanel_list">
// {state.length>0?
//                 state.map((item)=>(
                  
//                 <div class="col-12 col-md-4 mb-3">
//                         <div class="card  shadow-sm ">
//                             <div class="card-body">
//                                 <div class="text-center">
//                                     <figure>
//                                         <img src={`https://cdn.mojoship.in/channel_images/${item.channel_img}`} class="img-fluid" style={{height:"100px"}} />
//                                     </figure>
//                                     <h4>{item.channel_name}</h4>
//                                 </div>
                               
//                                 <div>
//                                 <small>Store Name</small>
//                             <h6 class="pt-3">{item.store_name}</h6>
//                             <span className='badge rounded-pill  bg-warning'>{item.status==5?"Pending":""}</span>

//                             <hr/>
//                             <div class="d-flex justify-content-between">
//                                 <div class="">
//                                     {item.status!=5?
//                                     <div class="form-check form-switch  mb-2">
//                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" defaultChecked={item.status} onChange={(e)=>handleChange(e , item.store_id)} name="status"/>
//                                        <label class="form-check-label" for="flexSwitchCheckChecked"><small>Active/Inactive</small></label>
//                                     </div>
//                                     :""}
//                                 </div>
//                                 <div class=" ">
//                                     <ul class="nav justify-content-end">
//                                         {/* <li class="nav-item">
//                                             <a class="nav-link text-danger" href="#" data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">delete</i></a>
//                                         </li> */}
//                                         {item.channel_id=="1507808901"?
//                                         <li class="nav-item">
//                                             <a class="nav-link text-danger" href={`/customer/channel_integrate/${item.channel_id}?user_id=${item.unique_user}`} data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">edit</i></a>
//                                         </li>
//                                         :""}
//                                     </ul>
//                                 </div>
                               
//                             </div>
//                             <div>
//                                     {item.status==2?"Error Please check your credientials":""}
//                                 </div>
//                             </div>


//                         </div>
//                     </div>
//                 </div>
                
// )):""}
//             </div>
//         </div>  
//         </section>
        
//     </section>


    
//     </div>
<div >
<Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="home-section">
         
          <Header/>

    <div class="row mb-2">
        <div class="col-12 col-md">
            <div class="d-flex">
                <div class="back_btn_wrap">
                    <a onClick={(e) => {
        e.preventDefault();
        navigate(-1); // This takes the user to the previous page
      }} class="back_btn">
                   <CornerUpLeft/>
                    </a>
                </div>
                <div class="">
                    <h2>Channels</h2>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-5 text-end btns">
            <a href="/customer/add_channel" class="btn btn-primary">Connect Channel</a>
        </div>
    </div>
    
    {state.length>0?
                 state.map((item)=>(
    <section>
        <div class="row channel_listing">
            <div class="col-12 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-2">
                            <figure>
                                <img src={`https://cdn.mojoship.in/channel_images/${item.channel_img}`} class="img-fluid" />
                            </figure>
                        </div>
                        <div class="col-12 col-md">
                            <h4>{item.store_name} </h4>
                            <p>Store ID: #{item.store_id}</p>
                            <p>Store url: {item.store_url}</p>
                            {/* {item.channel_id=="1567898605"?     <p>Webhook Url: {item.webhook_url?item.webhook_url:""} </p>:""}<br/> */}
                                                                   {/* {item.channel_id=="1567898605"? <>
                                                                        <h3> Create Webhook (Mandatory)</h3>
      <p>
        After installing the app, create a webhook in Shopify using the URL
        below:
      </p>

                                                            
      <ul>
                                                            <li>Login into Shopify Admin panel</li>
                                                            <li>
          Open{" "}
          <a
            href="https://admin.shopify.com"
            target="_blank"
            rel="noreferrer"
          >
            https://admin.shopify.com
          </a>
        </li>
                                                                <li>In the Shopify Admin panel, go to <strong>Settings</strong>.</li>
                                                                <li>Click on <strong>Notifications</strong> from the left-hand menu.</li>
                                                                <li>Scroll down to the <strong>Webhooks</strong> section and click on <strong>Create Webhook</strong>.</li>
                                                                <li>
  In the popup:
  <ul>
    <li>
      Select the <strong>Event</strong> <em>Order Creation</em> to sync your Shopify orders to our panel.
    </li>
    <li>
      Choose the <strong>Format</strong> (JSON is recommended).
    </li>
    <li>
      In the <strong>URL</strong> field, paste the following Webhook URL:
      <br />
      <code style={{ display: "block", marginBottom: 8 }}>
        {item.webhook_url ? item.webhook_url : ""}
      </code>
    </li>
    <li>Click <strong>Save</strong>.</li>

    <li style={{ marginTop: 10 }}>
      Again, click on <strong>Create Webhook</strong>.
    </li>
    <li>
      Select the <strong>Event</strong> <em>Order Update</em> to update your Shopify orders in our panel.
    </li>
    <li>
      Choose the <strong>Format</strong> (JSON is recommended).
    </li>
    <li>
      In the <strong>URL</strong> field, paste the following Webhook URL:
      <br />
      <code style={{ display: "block", marginBottom: 8 }}>
      https://backend.mojoship.in/webhook/shopify_update/{item.store_id}
      </code>
    </li>
    <li>Click <strong>Save</strong>.</li>
  </ul>
</li>

<li>Your webhooks are now active.</li>
                                                            </ul>
                                                            {item.store_api_key== undefined || item.store_api_key==""?
                                                            <div style={{ marginTop: 10, border: "1px solid #ddd", padding: 10 }}>
                                                            <h5>App Credentials</h5>

<p style={{ fontSize: 13, color: "#555" }}>
  This is a one-time setup and is required for:
</p>
<ul style={{ fontSize: 13, color: "#555" }}>
  <li>Auto update tracking numbers in Shopify</li>
  <li>Mark orders as fulfilled automatically</li>
</ul>

<p style={{ fontSize: 13, color: "#555" }}>
  To continue, please fill in your <b>Store URL</b>, <b>Client ID</b>, and{" "}
  <b>Client Secret</b>.
</p>

<p style={{ fontSize: 13, color: "#555" }}>
  We have already shown your <b>Store URL</b> above. Please fill that Store
  URL .
</p>

<p style={{ fontSize: 13, color: "#555" }}>
  To get your <b>Client ID</b> and <b>Client Secret</b>:
</p>
<ol style={{ fontSize: 13, color: "#555" }}>
  <li>Go to Shopify Partners Dashboard</li>
  <li>Click on <b>App distribution</b> → <b>All apps</b></li>
  <li>Click on <b>View on Dev Dashboard</b> for your app</li>
  <li>Go to <b>Settings</b> of that app</li>
  <li>You will see your <b>Client ID</b> and <b>Client Secret</b> there</li>
</ol>

    <input
      className="form-control mb-2"
      placeholder="Shopify Store URL (example.myshopify.com)"
      value={item.shop_input || ""}
      onChange={(e) =>
        updateStoreField(item.store_id, "shop_input", e.target.value)
      }
    />

    <input
      className="form-control mb-2"
      placeholder="Client ID"
      value={item.client_id_input || ""}
      onChange={(e) =>
        updateStoreField(item.store_id, "client_id_input", e.target.value)
      }
    />

    <input
      className="form-control mb-2"
      placeholder="Client Secret"
      value={item.client_secret_input || ""}
      onChange={(e) =>
        updateStoreField(item.store_id, "client_secret_input", e.target.value)
      }
    />

    <button
      className="btn btn-sm btn-success"
      onClick={() =>
        startShopifyOAuth(
          item.store_id,
          item.shop_input,
          item.client_id_input,
          item.client_secret_input
        )
      }
    >
      Submit
    </button>
  </div>:""}
                                                            </>:""} */}

                        </div>
                        <div class="col-12 col-md-3">
                            <span class={item.status==0?`badge rounded-pill bg-danger`:item.status==1?`badge rounded-pill bg-success`:""}><small>{item.status==0?"Inactive":item.status==1?"Active":""}</small></span>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        {/* <div class="col-12 col-md-8">
                            <a href="#" class="btn btn-sm btn-secondary-o"><i data-lucide="arrow-left-right"></i> Connections</a>
                        </div> */}
                        <div class="col-12 col-md text-end">
                            <div class="d-flex justify-content-end">
                                {/* <div class="">
                                   
                                    {item.channel_id=="1507808901" ?
                                        
                                        <a class="nav-link text-danger" href={`/customer/channel_integrate/${item.channel_id}?user_id=${item.unique_user}`} data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">edit</i></a>
                                 
                                    : <a class="nav-link text-danger" href={`/customer/edit_channel_integrate/${item.channel_id}/${item.store_id}`} data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">edit</i></a>
                                    }
                                </div> */}

                                <div class="">
                                   
                                        
                                        <a class="nav-link text-danger" onClick={(e)=>updateStatus(2,item.store_id)} data-bs-toggle="tooltip" title="Unlink Store"><i class="material-icons-outlined">delete</i></a>
                                 
                                   
                                </div>
                                
                                <div class="ps-2 ">
                                {item.status!=5?
                                    <div class="form-check form-switch  mb-2">
                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" defaultChecked={item.status} onChange={(e)=>handleChange(e , item.store_id)} name="status"/>
                                        <label class="form-check-label" for="flexSwitchCheckChecked"><small>Active/Inactive</small></label>
                                     </div>
                                     :""}
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>
           
        </div>
    </section>
                 )):""}
    
</div>

    

{/* <!-- Main content area END --> */}
<Footer/>
</div>
  )
}

export default Channel_list
